export default __webpack_public_path__ + "static/media/benefit_1.18470922.png";